import { Ref } from 'vue'

import { Incident } from '@collector/sportsapi-client'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEventId } from '@desktop/views/Relation/composables/useEventId'
import {
  queryOptions,
  useQuery,
  type UndefinedInitialQueryOptionsWithDataTag,
  type UseQueryReturnType,
} from '@tanstack/vue-query'

type EventIncidentsQueryKey = readonly ['event', 'incidents', Ref<number>]

type EventIncidentsQueryOptions = UndefinedInitialQueryOptionsWithDataTag<
  Incident[],
  Error,
  Incident[],
  EventIncidentsQueryKey
>

export function eventIncidentsQueryOptions(
  eventId: Ref<number>,
): EventIncidentsQueryOptions {
  return queryOptions({
    queryKey: ['event', 'incidents', eventId] as const,
    queryFn: async (): Promise<Incident[]> => {
      const response = await sportsApiClient.Events.Incidents.get(
        eventId.value,
        {
          sort_type: 'id',
          sort_order: 'asc',
          limit: 99999,
        },
      )

      return response.api.data.event_incidents
    },
  })
}

export const useEventIncidentsQuery = (
  options?: Omit<EventIncidentsQueryOptions, 'queryKey' | 'queryFn'>,
): UseQueryReturnType<Incident[], Error> => {
  const eventId = useEventId()
  return useQuery<Incident[], Error, Incident[], EventIncidentsQueryKey>({
    ...eventIncidentsQueryOptions(eventId),
    ...options,
  })
}
